import React from 'react';
import { Form, Input, Button, Select, Row, Col, DatePicker } from 'antd';
import styles from './RatingsFilterForm.scss';
import { UserRatingStatusText, UserRatingStatus, RatingSortOption } from '../../../../models/enums';

const { RangePicker } = DatePicker;

// eslint-disable-next-line max-lines-per-function
const RatingsFilterForm = ({ onSubmit, className, form, value }) => {
  const defaultFilters = {
    status: UserRatingStatus.notReviewed,
    sortOption: RatingSortOption.Oldest
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = form.getFieldsValue();

    // Convert date range to dateFrom/dateTo
    if (values.dateRange && values.dateRange.length === 2) {
      values.dateFrom = values.dateRange[0].format('YYYY-MM-DD');
      values.dateTo = values.dateRange[1].format('YYYY-MM-DD');
      delete values.dateRange;
    }

    // Always include sortOption (oldest first for admin)
    values.sortOption = RatingSortOption.Oldest;

    onSubmit(values);
  };

  const handleReset = () => {
    form.resetFields();
    // Reset to default filters (notReviewed, oldest first)
    form.setFieldsValue({ status: defaultFilters.status });
    onSubmit(defaultFilters);
  };

  return (
    <Form layout="inline" onSubmit={handleSubmit} className={`${styles.form} ${className}`}>
      <Row>
        <Col xs={24} sm={19} md={16} lg={19}>
          <Form.Item>
            {form.getFieldDecorator('code')(
              <Input className={styles.textInput} placeholder="Kod oglasa" />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('email')(
              <Input className={styles.textInput} placeholder="Email" />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('status', {
              initialValue: value && value.status !== undefined ? value.status : undefined
            })(
              <Select
                placeholder="Status"
                className={styles.moduleDropdown}
                allowClear
              >
                {UserRatingStatusText.map(status => (
                  <Select.Option key={status.value} value={status.value}>
                    {status.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('dateRange')(
              <RangePicker
                format="DD.MM.YYYY"
                className={styles.dateRange}
                style={{width: 320}}
              />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} sm={5} md={8} lg={5}>
          <Form.Item>
            <Button className={styles.control} type="primary" htmlType="submit">
              {"Traži"}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button className={styles.control} onClick={handleReset}>
              {"Resetiraj"}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

RatingsFilterForm.defaultProps = {
  className: ''
};

export default Form.create()(RatingsFilterForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageRatingsPage/RatingsFilterForm/index.tsx